import React from 'react'
import Header from './widgets/Header'
import Landing from './widgets/Landing'

export default function Index() {
  return (
    <div className='Index'>
        <Header />
        <Landing />
    </div>
  )
}
